import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailVerificationModalComponent } from '../components/email-verification-modal/email-verification-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationModalService {
  private dialog = inject(MatDialog);
  private isModalOpen = false;

  showVerificationModal(): void {
    if (this.isModalOpen) {
      return;
    }

    this.isModalOpen = true;

    const dialogRef = this.dialog.open(EmailVerificationModalComponent, {
      width: '400px',
      maxWidth: '90vw',
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'email-verification-dialog-panel',
      data: {}
    });

    dialogRef.afterClosed().subscribe(() => {
      this.isModalOpen = false;
    });
  }

  closeModal(): void {
    this.dialog.closeAll();
    this.isModalOpen = false;
  }

  /**
   * Shows the verification modal with a delay to ensure auth dialog closes first.
   * Used after login or registration to avoid dialog conflict.
   */
  showVerificationModalWithDelay(): void {
    setTimeout(() => {
      this.showVerificationModal();
    }, 1000);
  }

  /** @deprecated Use showVerificationModalWithDelay instead */
  showVerificationModalOnRegistration(): void {
    this.showVerificationModalWithDelay();
  }
}
